import { checkNested } from "./generalUtils";
import { isNothing } from "./langUtils";

export const MAX_AMOUNT = 999;

export function addonIsOnBlacklist(addons: $TSFixMe, countryCode: $TSFixMe) {
  const addonsNotAllowed: $TSFixMe = [];
  if (addons) {
    addons.forEach((addon: $TSFixMe) => {
      if (
        addon.amount > 0 &&
        addon.planVariantAddon.countryBlacklist.includes(countryCode)
      ) {
        addonsNotAllowed.push(addon.planVariantAddon.name);
      }
    });
  }
  return addonsNotAllowed;
}

export function chooseRelevantCountryCode(
  object: $TSFixMe,
  shippingDifferent = true,
) {
  let relevantCountryCode = null;
  // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 2.
  if (checkNested(object.billingAddress, "countryCode")) {
    relevantCountryCode = object.billingAddress.countryCode;
    // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 3.
  } else if (checkNested(object.billingAddress, "country", "code")) {
    relevantCountryCode = object.billingAddress.country.code;
  }
  if (shippingDifferent) {
    // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 2.
    if (checkNested(object.shippingAddress, "countryCode")) {
      relevantCountryCode = object.shippingAddress.countryCode;
      // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 3.
    } else if (checkNested(object.shippingAddress, "country", "code")) {
      relevantCountryCode = object.shippingAddress.country.code;
    }
  }
  return relevantCountryCode;
}

export function checkAddonBlacklist(
  planCart: $TSFixMe,
  shippingDifferent = true,
) {
  let addonsNotAllowed = [];
  const relevantCountryCode = chooseRelevantCountryCode(
    planCart,
    shippingDifferent,
  );
  if (relevantCountryCode && planCart.addons && planCart.addons.length > 0) {
    addonsNotAllowed = addonIsOnBlacklist(planCart.addons, relevantCountryCode);
  }
  return addonsNotAllowed;
}

export function addonVisibleForUserrole(
  userRoles: $TSFixMe,
  addonRoles: $TSFixMe,
) {
  if (isNothing(addonRoles) || addonRoles.length === 0) return true;
  if (isNothing(userRoles) || userRoles.length === 0) return false;

  let hasRole = false;
  userRoles.forEach((role: $TSFixMe) => {
    if (addonRoles.includes(role.name)) {
      hasRole = true;
    }
  });
  return hasRole;
}

export function addonMaxAmount(addon: $TSFixMe, planVariant: $TSFixMe) {
  if (planVariant?.assets > 0) {
    if (addon?.id?.endsWith("-connected-asset")) {
      return planVariant.assets;
    }
    if (addon?.id?.endsWith("heartbeat-verification")) {
      return planVariant.assets;
    }
  }

  if (
    addon?.id?.includes("-opc-ua-server") ||
    addon?.id?.includes("-liquiline-assist")
  ) {
    return 1;
  }
  const planName =
    typeof planVariant?.name === "string"
      ? planVariant.name.toLowerCase()
      : null;
  if (planName && addon?.max_amount && planName in addon.max_amount) {
    return addon.max_amount[planName];
  }
  return MAX_AMOUNT;
}
